@if (canShow) {
  <button
    mat-menu-item
    (click)="onApplyMastersuite()"
    [disabled]="selectedProducts.length === 0"
    >
    <mat-icon>lightbulb</mat-icon>
    <span>Apply Mastersuite</span>
  </button>
}
